import React from "react";
import PlacementSection from "../../Sections/PlacementSection/Content";
const PlacementPage = () => {
  return <PlacementSection />;
};

export default PlacementPage;
